export default __webpack_public_path__ + "static/2021 CVN English-f2a8a8b4f4c0b4882d78fd77f01ed5ed.pdf";